<template lang="pug">
.meeting-item
  .title
    h1  {{ editHeadingStr }}
  .form-body
    aiq-form(label-width="120px")
      aiq-form-item(v-if="integrationType === 'ms-outlook'" label="Integration" required)
        ms-outlook-icon.outlook-icon

      aiq-form-item(label="Type" required)
        aiq-select.select-size(v-model="event.event_type"
                                placeholder="Select Type"
                                size="small"
                                :clear-icon="Icon.CircleCloseFilled"
                                :suffix-icon="Icon.CaretBottom"
                                :disabled="true")
          aiq-option(v-for="item in supportingEvents"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value")

      aiq-form-item(label="Start" required)
        aiq-col(:span="11")
          aiq-date-picker.el-input__inner(v-model="endDate"
                                          type="date"
                                          popper-class="date-picker-popup"
                                          style="width: 100%;"
                                          :disabled-date="disabledDate"
                                          :clearable="false"
                                          placeholder="Select date"
                                          format="YYYY/MM/DD"
                                          :disabled="true")
        aiq-col(:span="2")
          .dash -
        aiq-col(:span="11")
          aiq-time-select.time-pick-input(v-model="endTime"
                                          popper-class="time-picker-popup"
                                          :start="startTime"
                                          step="00:15"
                                          end="23:45"
                                          placeholder="Select time"
                                          :clearable="false"
                                          :disabled="true")

      aiq-form-item(label="End" required)
        aiq-col(:span="11")
          aiq-date-picker.el-input__inner(v-model="startDate"
                                          type="date"
                                          popper-class="date-picker-popup"
                                          style="width: 100%;"
                                          :disabled-date="disabledDate"
                                          :clearable="false"
                                          placeholder="Select date"
                                          format="YYYY/MM/DD"
                                          :disabled="true")
        aiq-col(:span="2")
          .dash -
        aiq-col(:span="11")
          aiq-time-select.time-pick-input(v-model="startTime"
                                          popper-class="time-picker-popup"
                                          :start="startTime"
                                          step="00:15"
                                          end="23:45"
                                          placeholder="Select time"
                                          :clearable="false"
                                          :disabled="true")
      aiq-form-item(label="All day Event")
        aiq-checkbox(v-model="event.is_all_day" :disabled="true")
      aiq-form-item(label="Location")
        a(v-if="isValidUrl(event.location)" :href="event.location" target="_blank") {{ event.location }}
        span(v-else) {{ event.locaiton }}
      aiq-form-item(label="Meeting")
        a(v-if="event.meeting_link !== ''" :href="event.meeting_link" target="_blank") {{ event.meeting_link }}
      aiq-form-item(label="Organizer")
        aiq-input(v-model="event.organizer"
                  :disabled="true")
      aiq-form-item(label="Attendees")
        aiq-keyword-input(:list="event.attendees" :disabled="true")
      aiq-form-item(label="Title")
        aiq-input(v-model="event.title"
                  placeholder="Title"
                  :disabled="true")
      aiq-form-item(label="Description")
        aiq-input(v-html="event.description"
                  type="textarea"
                  placeholder="Description"
                  :disabled="true")
</template>

<script>
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import dayjs from '@/localPlugins/dayjs';
import { isValidUrl } from '@/libs';

import MsOutlookIcon from '@/assets/svg/ms-outlook.vue';

export default {
  name: 'MeetingItem',
  components: {
    MsOutlookIcon,
  },
  computed: {
    disabled() {
      return !isEmpty(get(event, 'integration_type'));
    },
    startDate() {
      return (this.event) ? dayjs(this.event.starts_at).toDate() : null;
    },
    startTime() {
      return (this.event) ? dayjs(this.event.ends_at).format('HH:mm') : '';
    },
    endDate() {
      return (this.event) ? dayjs(this.event.ends_at).toDate() : null;
    },
    endTime() {
      return (this.event) ? dayjs(this.event.starts_at).format('HH:mm') : '';
    },
    integrationType() {
      return this.event.integration_type;
    },
  },
  props: {
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
  },
  async mounted() {
  },
  methods: {
    isValidUrl,
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/aiq-variables.scss";

.outlook-icon {
  height: 32px;
  width: 32px;
}
</style>
